import { Grid, CircularProgress } from '@mui/material';

const Loader = () => {
  return (
    <Grid
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
    >
      <CircularProgress disableShrink />
    </Grid>
  );
};

export default Loader;
